module.exports = __webpack_public_path__ + "static/stripe-a3d6097eea8cb66581312e7f0bf386fc.png";